import type { TrackedTranslation, TranslationTag } from '@ps/web-core-intl';

export enum PageType {
  Eula = 'eula',
  Privacy = 'privacy',
  PFP = 'pfp'
}

export interface PageContentTypes {
  link: string;
  title: TrackedTranslation | TranslationTag;
}
